export const BrowserStorage = {
  set: (key: string, value: any): void => sessionStorage.setItem(key, value),
  get: (key: string): string | null => sessionStorage.getItem(key),
  remove: (key: string): void => sessionStorage.removeItem(key)
};
